import React, {useMemo, useState} from "react";
import {EmailShareButton, FacebookShareButton, TelegramShareButton, TwitterShareButton} from "react-share";
import {ReactComponent as Twitter} from "../../../../../assets/images/content/twitter.svg";
import {ReactComponent as Facebook} from "../../../../../assets/images/content/facebook.svg";
import {ReactComponent as Email} from "../../../../../assets/images/content/email.svg";
import {ReactComponent as Telegram} from "../../../../../assets/images/content/telegram.svg";
import IconButton from "../../../base/button/icon_button";
import {SvgIcon} from "@mui/material";
import {ReactComponent as Share} from "../../../../../assets/images/share.svg";
import classnames from "classnames";
import {useLocation} from "react-router-dom";

const ShareContent = ({title, body}) => {
    const location = useLocation();
    const [hovering, setHovering] = useState(false);

    const url = useMemo(() => window.location.origin.concat(location.pathname), [location.pathname]);

    return (
        <>
            <div
                className={'share-socials'}
            >
                <div
                    className={classnames('social-icons', {'open': hovering})}
                    onMouseLeave={() => setHovering(false)}
                    onMouseEnter={() => setHovering(true)}
                >
                    <TelegramShareButton
                        title={`${title} \n\n${body}`}
                        className={'social-icon'}
                        url={url}
                    >
                        <Telegram/>
                    </TelegramShareButton>
                    <FacebookShareButton
                        className={'social-icon'}
                        quote={`${title} \n\n${body}`}
                        url={url}
                    >
                        <Facebook/>
                    </FacebookShareButton>
                    <TwitterShareButton
                        className={'social-icon'}
                        title={`${title} \n\n${body}`}
                        url={url}
                    >
                        <Twitter/>
                    </TwitterShareButton>
                    <EmailShareButton
                        className={'social-icon'}
                        url={url}
                        subject={title}
                        body={`${title} \n\n${body}`}
                        separator={'\n\n'}
                    >
                        <Email/>
                    </EmailShareButton>
                </div>
                <IconButton
                    color={'paper.secondary'}
                    className={'z-index-1'}
                    onMouseLeave={() => setHovering(false)}
                    onMouseEnter={() => setHovering(true)}
                >
                    <SvgIcon className='icon normal' component={Share}/>
                </IconButton>

            </div>
        </>
    )
}

export default ShareContent;
